export class InformacionGeneralPj {

    optionLabel = 'nombre';

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                header: 'Código',
            },
            fecha: {
                value: new Date(),
                export: false,
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            // A. INFORMACIÓN GENERAL DE LA EMPRESA
            razon_social: {
                value: '',
                export: true,
                header: 'Razón Social:',
                required: 'Razón social es requerida',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            nombre_comercial: {
                value: '',
                export: true,
                header: 'Nombre Comercial:',
                maxLength: 'Máximo 250 caracteres',
                max: 250,
            },
            nacionalidad: {
                value: null,
                export: false,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerida'
            },
            tipo_entidad: {
                value: null,
                export: false,
                header: 'Tipo de entidad:',
                required: 'Tipo de entidad es requerido'
            },
            tipo_estructura: {
                value: null,
                export: false,
                header: 'TIPO / ESTRUCTURA LEGAL',
                required: 'Campo requerido'
            },
            ruc: {
                value: '',
                export: true,
                header: 'RUC:',
                required: 'RUC es requerido',
                maxLength: 'Exactamente 13 caracteres',
                minLength: 'Exactamente 13 caracteres',
                max: 13,
                min: 13,
            },
            pais_oficina: {
                value: null,
                export: false,
                header: 'País de oficina:',
                required: 'País es requerido'
            },
            provincia_oficina: {
                value: null,
                export: false,
                header: 'Provincia de oficina:',
            },
            ciudad_oficina: {
                value: null,
                export: false,
                header: 'Cantón / Ciudad de oficina:',
            },
            ciudad_oficina_txt: { // Para cuando es extranjero
                value: '',
                export: false,
                header: 'Ciudad (Extranjero):',
                max: 250,
                required: 'Ciudad (Extranjero) es requerida',
            },
            direccion_oficina: {
                value: '',
                export: false,
                header: 'Dirección oficina:',
                max: 500,
                required: 'Dirección es requerida'
            },
            telefono: {
                value: '',
                export: false,
                header: 'Teléfono empresa:',
                max: 40,
                required: 'Teléfono es requerido'
            },
            email: {
                value: '',
                export: false,
                header: 'E-mail empresa:',
                max: 200,
                required: 'E-mail es requerido',
            },
            // B. REPRESENTANTE LEGAL
            apellido_paterno_rep: {
                value: '',
                export: true,
                header: 'Apellido Paterno (Rep.):',
                required: 'Campo requerido',
                max: 250,
            },
            apellido_materno_rep: {
                value: '',
                export: true,
                header: 'Apellido Materno (Rep.):',
                max: 250,
            },
            nombres_rep: {
                value: '',
                export: true,
                header: 'Nombres (Rep.):',
                required: 'Campo requerido',
                max: 250,
            },
            tipo_identificacion_rep: {
                value: null,
                export: false,
                header: 'Tipo de documento (Rep.):',
                required: 'Tipo de identificación es requerido'
            },
            identificacion_rep: {
                value: '',
                export: false,
                header: 'No. de Identificación (Rep.):',
                required: 'Identificación es requerida',
                max: 50,
            },
            genero_rep: {
                value: null,
                export: false,
                header: 'Sexo:',
                required: 'Género es requerido'
            },
            estado_civil_rep: {
                value: null,
                export: false,
                header: 'Estado civil:',
                required: 'Estado civil es requerido'
            },
            nacionalidad_rep: {
                value: null,
                export: false,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerida'
            },
            pais_residencia_rep: {
                value: null,
                export: false,
                header: 'País de residencia:',
                required: 'País de residencia es requerido'
            },
            provincia_residencia_rep: {
                value: null,
                export: false,
                header: 'Provincia de residencia:',
            },
            ciudad_residencia_rep: {
                value: null,
                export: false,
                header: 'Ciudad de residencia:',
            },
            ciudad_residencia_rep_txt: {
                value: '',
                export: false,
                header: 'Ciudad (Extranjero):',
                max: 250,
                required: 'Ciudad (Extranjero) del representante es requerido.'
            },
            direccion_residencia_rep: {
                value: '',
                export: false,
                header: 'Dirección de residencia:',
                max: 500,
                required: 'La dirección de residencia es requerida',
            },
            telefono_rep: {
                value: '',
                export: false,
                header: 'Teléfono (Fijo):',
                max: 40,
                required: 'El teléfono es requerido',
            },
            fax_rep: {
                value: '',
                export: false,
                header: 'Fax:',
                max: 40,
            },
            celular_rep: {
                value: '',
                export: false,
                header: 'Celular:',
                max: 40,
            },
            email_rep: {
                value: '',
                export: false,
                header: 'E-Mail (Rep.):',
                max: 200,
                required: 'El E-mail del representante es requerido' 
            },
            direccion_extranjero_rep: {
                value: '',
                export: false,
                header: 'Si es residente/ciudadano de EEUU u otro país, indique el país, estado y dirección de residencia:',
                max: 500,
            },
        }
    }
}